import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VTextField,_vm._b({attrs:{"value":_vm.value}},'v-text-field',_vm.schema['x-props'],false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }